import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import StringUtil from 'utilities/string_util'
import ImagePickerItem, { ImagePickerUploadItem } from 'entities/image_picker_item'

const Uploader = ({ pickerItem, onChangePickerItem }) => {
  if (pickerItem.url && !pickerItem.isDefaultImage) {
    return null
  }

  const onUploadImage = e => {
    const { files } = e.target
    const file = files[0]
    const blobUrl = window.URL.createObjectURL(file)

    if (isEmpty(blobUrl)) {
      return
    }

    const newPickerItem = new ImagePickerUploadItem(blobUrl, file)
    onChangePickerItem(newPickerItem)
  }
  const inputHtmlFor = `input-file-${StringUtil.getRandomString()}`

  return (
    <div className="form-group">
      <div className="form-label">{I18n.t('components.image_picker_uploader.label')}</div>
      <div className="form-group-uploader">
        <input type="file" id={inputHtmlFor} className="file-control" onChange={e => onUploadImage(e)} />
        <label className="btn btn-upload" htmlFor={inputHtmlFor}>
          {I18n.t('components.image_picker_uploader.file_select.label')}
        </label>
      </div>
    </div>
  )
}

Uploader.propTypes = {
  pickerItem: PropTypes.instanceOf(ImagePickerItem).isRequired,
  onChangePickerItem: PropTypes.func.isRequired
}

export default Uploader
